import { Role } from '@okletsplay/core';
import { ModalName, Route } from 'app/enums';
import { NavigationMenuItem } from 'app/interfaces/sidebar';
import { AppCountersContext } from 'app/providers/AppCountersProvider';
import gamepadIcon from 'assets/images/gamepad_icon.svg';
import homeIcon from 'assets/images/home_icon.svg';
import { useCallback, useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import plusIcon from 'assets/images/plus_icon.svg';
import { modalsReducers } from 'app/store/modal/slice';
import { useDispatch } from 'react-redux';

interface GeneralMenuItemsHook {
  generalMenuItems: NavigationMenuItem[];
}

export function useGeneralMenuItems(): GeneralMenuItemsHook {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { activeMatchesCount, participatedTournamentsCount } = useContext(AppCountersContext);

  const openModal = useCallback(() => {
    dispatch(modalsReducers.openModal({ name: ModalName.CreateMatch }));
  }, [dispatch]);

  const generalMenuItems = useMemo((): NavigationMenuItem[] => {
    return [
      {
        label: 'Home',
        onClick: () => navigate(Route.Home),
        route: Route.Home,
        icon: homeIcon,
        roles: [Role.User],
        isAllowedWithoutAuthorization: true,
      },
      {
        label: 'My Activity',
        badge: activeMatchesCount + participatedTournamentsCount,
        onClick: () => navigate(Route.MyActiveMatches),
        route: Route.MyActiveMatches,
        icon: gamepadIcon,
        roles: [Role.User],
        dataTestId: 'my-activity-menu-item',
      },
      {
        label: 'Create Match',
        icon: plusIcon,
        onClick: openModal,
        dataTestId: 'create-match-menu-item',
        isAllowedWithoutAuthorization: true,
      },
    ];
  }, [activeMatchesCount, navigate, openModal, participatedTournamentsCount]);

  return { generalMenuItems };
}
